import { render } from "./Training.vue?vue&type=template&id=8220340e&scoped=true"
import script from "./Training.vue?vue&type=script&lang=js"
export * from "./Training.vue?vue&type=script&lang=js"

import "./Training.vue?vue&type=style&index=0&id=8220340e&scoped=true&lang=scss"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8220340e"]])

export default __exports__